import { useState, useEffect, useCallback } from "react";
import * as SurveyAPI from "../../services/surveyService";

export function useConsent() {
  const [consent, setConsent] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    SurveyAPI.fetchConsent()
      .then(setConsent)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const grant = useCallback(async (consentType, { consentTextVersion, sourceContext } = {}) => {
    const result = await SurveyAPI.recordConsent({
      consentType,
      granted: true,
      consentTextVersion,
      sourceContext,
    });
    setConsent((prev) => ({
      ...prev,
      [consentType]: { granted: true, consent_text_version: consentTextVersion },
    }));
    return result;
  }, []);

  const revoke = useCallback(async (consentType, { consentTextVersion, sourceContext } = {}) => {
    const result = await SurveyAPI.recordConsent({
      consentType,
      granted: false,
      consentTextVersion,
      sourceContext,
    });
    setConsent((prev) => ({
      ...prev,
      [consentType]: { ...prev[consentType], granted: false },
    }));
    return result;
  }, []);

  return { consent, loading, grant, revoke };
}
